import { sanitizeFilename } from './report-export.utils';

export function normalizeExcelFilename(filename: string): string {
  const normalizedFilename = sanitizeFilename(filename) || 'report';
  return normalizedFilename.toLowerCase().endsWith('.xlsx') ? normalizedFilename : `${normalizedFilename}.xlsx`;
}

